export default __webpack_public_path__ + "static/media/logo__technology__ubuntu.6756ad2d.png";